<template>
  <div
    :class="[
      $style.root,
      {
        [$style.vertical]: props.direction === 'vertical',
        [$style.appearanceBorder]: props.appearance === 'border',
      },
    ]"
    :style="{ margin }"
    role="separator"
  />
</template>
<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    direction?: "horizontal" | "vertical";
    appearance?: "default" | "border";
    margin?: string;
  }>(),
  {
    direction: "horizontal",
    appearance: "default",
    margin: undefined,
  },
);
</script>

<style module lang="scss">
.root {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;

  &.vertical {
    align-self: stretch;
  }

  &.appearanceBorder {
    height: 1px;
    background-color: var(--color-border-default);

    &.vertical {
      width: 1px;
      height: unset;
    }
  }
}
</style>
